import get from "lodash-es/get";
import {
  EMAIL_TEMPLATES,
  EVENTS,
  IQ_CONFIG_SCHEMA,
  IQ_CONFIGURATION,
  IQ_PATCH_TAGS,
} from "constants/FileNames";
import {
  EVENT_TITLE_TO_TYPE_MAP,
  EVENTS_TYPE_DP,
  EVENTS_TYPE_NEO,
  EVENTS_TYPE_PM,
  EVENTS_TYPE_IQ,
  EVENTS_TYPE_VP,
} from "constants/eventsTypes";

export const _getIQConfigInfo = (data) => {
  return {
    name: IQ_CONFIGURATION,
    hasFile: !!data.length,
    info: data.map((info) => ({
      id: info.id_config && Number(info.id_config),
      name: info.filename,
    })),
  };
};

export const _getIQPatchTags = (data) => {
  return {
    name: IQ_PATCH_TAGS,
    hasFile: !!get(data, "id_file", null),
    info: {
      idFile: get(data, "id_file", null),
      patchTags: get(data, "patch_tags", []).map((patchTag, index) => ({
        id: index,
        patchTag,
      })),
    },
  };
};

export const _getIQConfigSchemaInfo = (data) => {
  const files = data.map(({ id_config, filename }) => ({
    id: Number(id_config),
    name: filename,
  }));
  return {
    name: IQ_CONFIG_SCHEMA,
    hasFile: !!files.length,
    info: files,
  };
};

export const _getEmailTemplatesInfo = (data) => {
  const files = data.map(({ id_file, filename, description }) => ({
    id: Number(id_file),
    name: filename,
    description,
  }));
  return {
    name: EMAIL_TEMPLATES,
    hasFile: !!files.length,
    info: files,
  };
};

export const _getEventsInfo = (data, idKey) => {
  const info = [
    _getEventInfoByType(data, EVENTS_TYPE_PM, idKey),
    _getEventInfoByType(data, EVENTS_TYPE_NEO, idKey),
    _getEventInfoByType(data, EVENTS_TYPE_DP, idKey),
    _getEventInfoByType(data, EVENTS_TYPE_VP, idKey),
    _getEventInfoByType(data, EVENTS_TYPE_IQ, idKey),
  ];
  const hasFile = info.some((eventInfo) => eventInfo.hasFile);
  return {
    name: EVENTS,
    hasFile,
    info,
  };
};

const _getEventInfoByType = (data, type, idKey) => {
  const eventInfo =
    data.find((event) => event.file_type === EVENT_TITLE_TO_TYPE_MAP[type]) ||
    {};
  const id = Number(eventInfo[idKey]);
  const name = eventInfo.filename;
  return { id, name, type, hasFile: !!name };
};
